import { render, staticRenderFns } from "./PatientSearchRecommendations.vue?vue&type=template&id=16400df0&scoped=true"
import script from "./PatientSearchRecommendations.vue?vue&type=script&lang=js"
export * from "./PatientSearchRecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16400df0",
  null
  
)

export default component.exports